import { Languages } from "../../../enums/languages";

const renewedPermitModalLang = {
    "modal-title": {
        [Languages.Hebrew]: { default: "חידוש תו חניה" },
        [Languages.Arabic]: { default: "تجديد تصريح الانتظار" },
        [Languages.English]: { default: "Renew Parking Permit" }
    },
    "form": {
        "ownership-car-label": {
            [Languages.Hebrew]: { default: "בעלות הרכב" },
            [Languages.Arabic]: { default: "ملكية السيارة" },
            [Languages.English]: { default: "Car Ownership" }
        },
        "private-car-label": {
            [Languages.Hebrew]: { default: "פרטי" },
            [Languages.Arabic]: { default: "خاص" },
            [Languages.English]: { default: "Private" }
        },
        "company-car-label": {
            [Languages.Hebrew]: { default: "חברה" },
            [Languages.Arabic]: { default: "شركة" },
            [Languages.English]: { default: "Company" }
        },
        "comment-label": {
            [Languages.Hebrew]: { default: "הערה" },
            [Languages.Arabic]: { default: "تعليق" },
            [Languages.English]: { default: "Comment" }
        },
        "scan-person-id-label": {
            [Languages.Hebrew]: { default: "צילום תעודת זהות" },
            [Languages.Arabic]: { default: "تصوير بطاقة الهوية" },
            [Languages.English]: { default: "Scan Person ID" }
        },
        "scan-car-id-label": {
            [Languages.Hebrew]: { default: "צילום רשיון רכב(שים לב לא רשיון נהיגה!)" },
            [Languages.Arabic]: { default: "تصوير رخصة السيارة (ملاحظة: ليس رخصة القيادة!)" },
            [Languages.English]: { default: "Scan Car ID (Note: Not Driver's License!)" }
        },
        "scan-work-statement-label": {
            [Languages.Hebrew]: { default: "צילום הצהרה ממקום העבודה/מחברת הליסינג" },
            [Languages.Arabic]: { default: "تصوير بيان من مكان العمل / شركة التأجير" },
            [Languages.English]: { default: "Scan Work Statement" }
        },
        "declaration-title": {
            [Languages.Hebrew]: { default: "הצהרה חשובה" },
            [Languages.Arabic]: { default: "إعلان مهم" },
            [Languages.English]: { default: "Important Declaration" }
        },
        "declaration-body": {
            [Languages.Hebrew]: { default: "הגשת בקשה עבור חידוש תו חניה עבור רכב חברה מצריכה הצהרה חתומה ממקום העבודה או מחברת הליסינג." },
            [Languages.Arabic]: { default: "تقديم طلب لتجديد تصريح الانتظار لسيارة الشركة يتطلب إعلانًا موقعًا من مكان العمل أو شركة التأجير." },
            [Languages.English]: { default: "Submitting a request for renewing a parking permit for a company car requires a signed declaration from the workplace or leasing company." }
        },
        "credit-card": {
            "section-title": {
                [Languages.Hebrew]: { default: "פרטי התשלום" },
                [Languages.Arabic]: { default: "تفاصيل الدفع" },
                [Languages.English]: { default: "Payment Details" }
            },
            "card-number-label": {
                [Languages.Hebrew]: { default: "מספר כרטיס אשראי" },
                [Languages.Arabic]: { default: "رقم بطاقة الائتمان" },
                [Languages.English]: { default: "Credit Card Number" }
            },
            "card-expire-year-label": {
                [Languages.Hebrew]: { default: "תוקף שנה" },
                [Languages.Arabic]: { default: "تاريخ انتهاء الصلاحية (سنة)" },
                [Languages.English]: { default: "Expiration Year" }
            },
            "card-expire-month-label": {
                [Languages.Hebrew]: { default: "תוקף חודש" },
                [Languages.Arabic]: { default: "تاريخ انتهاء الصلاحية (شهر)" },
                [Languages.English]: { default: "Expiration Month" }
            },
            "card-cvv-label": {
                [Languages.Hebrew]: { default: "CVV" },
                [Languages.Arabic]: { default: "CVV" },
                [Languages.English]: { default: "CVV" }
            },
            "card-holder-id-label": {
                [Languages.Hebrew]: { default: "תעודת זהות של בעל הכרטיס" },
                [Languages.Arabic]: { default: "رقم الهوية لحامل البطاقة" },
                [Languages.English]: { default: "Card Holder ID" }
            },
            "card-holder-name-label": {
                [Languages.Hebrew]: { default: "שם על גבי הכרטיס(באנגלית)" },
                [Languages.Arabic]: { default: "اسم حامل البطاقة (بالإنجليزية)" },
                [Languages.English]: { default: "Card Holder Name (in English)" }
            }
        }
    },
    "renewed-permit-confirmation": {
        "confirmation-line-1": {
            [Languages.Hebrew]: { default: "בקשת חידוש תו החניה בוצעה בהצלחה." },
            [Languages.Arabic]: { default: "تم تقديم طلب تجديد تصريح الانتظار بنجاح." },
            [Languages.English]: { default: "Parking permit renewal request was successful." }
        },
        "confirmation-line-2": {
            [Languages.Hebrew]: { default: "שולם" },
            [Languages.Arabic]: { default: "تم الدفع" },
            [Languages.English]: { default: "Paid" }
        },
        "confirmation-line-3": {
            [Languages.Hebrew]: { default: "מספר אסמכתא" },
            [Languages.Arabic]: { default: "رقم الإيصال" },
            [Languages.English]: { default: "Receipt Number" }
        }
    },
    "buttons": {
        "print-receipt-btn-tag": {
            [Languages.Hebrew]: { default: "הדפס קבלה" },
            [Languages.Arabic]: { default: "طباعة الإيصال" },
            [Languages.English]: { default: "Print Receipt" }
        },
        "send-form-btn-tag": {
            [Languages.Hebrew]: { default: "שלח טופס" },
            [Languages.Arabic]: { default: "إرسال النموذج" },
            [Languages.English]: { default: "Send Form" }
        }
    }
};

export default renewedPermitModalLang;